module.exports = __webpack_public_path__ + "img/02-man.f32602d7.svg";